import React from 'react';
import { checkRequired, useFormContext } from '../../../hoc/form';

export default function FormRequirements({ enabled, require, match = null, noMatch = null, styleMatch, styleNoMatch, ...props }) {
	const context = useFormContext();
	if(!context) {
		return null;
	}
	const show = checkRequired(enabled, context.values);
	if(!show) {
		return null;
	}
	const matches = checkRequired(require, context.values);
	let style = props.style;
	if (matches && styleMatch) {
		style = { ...style, ...styleMatch };
	} else if(!matches && styleNoMatch) {
		style = { ...style, ...styleNoMatch };
	}
	return <span {...props} style={style}>{matches ? match : noMatch}</span>;
}
